import { BreakpointObserver } from '@angular/cdk/layout'

/**
 * Observador de breakpoint compartilhado, usado por quem estende o
 * BaseComponentComponent.
 *
 * Mora aqui, e não no app.module, porque o módulo declara o AppComponent, que
 * por sua vez estende o BaseComponentComponent: importar o app.module de volta
 * fechava um ciclo. No navegador o bundler resolvia; no Jest o ciclo devolvia
 * undefined e nenhuma suíte que tocasse no AppComponent conseguia rodar.
 */
export let AppResponsive: BreakpointObserver

/** Chamado uma vez pelo AppModule: só o módulo que declara pode reatribuir. */
export function setAppResponsive(observer: BreakpointObserver): void {
  AppResponsive = observer
}
